module.exports = "/images/gotham-11.jpg";